import React, { useState, useRef } from 'react';
import { Typography, Paper, Popover, Box, IconButton } from '@mui/material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';

export default function TooltipPopover({ children }) {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleOpenTooltipPopover = () => setOpen(true);
  const handleCloseTooltipPopover = () => setOpen(false);

  return (
    <Box
      onMouseEnter={handleOpenTooltipPopover}
      onMouseLeave={handleCloseTooltipPopover}
      sx={{ display: 'inline-flex', alignItems: 'center' }}
    >
      <IconButton
        ref={anchorRef}
        size="small"
        sx={{ p: 0.5 }}
      >
        <HelpOutlineRoundedIcon fontSize="small" />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorRef.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handleCloseTooltipPopover}
        disableRestoreFocus
        disableEnforceFocus
        disableAutoFocus
        disableScrollLock
        PaperProps={{
          onMouseEnter: handleOpenTooltipPopover,
          onMouseLeave: handleCloseTooltipPopover,
          sx: { p: 2, maxWidth: '32rem' },
        }}
      >
        <Typography sx = {{ whiteSpace: 'pre-line' }}>{children}</Typography>
      </Popover>
    </Box>
  );
}

